import { hexToNumber } from '../../utils/encoding/fromHex.js';
export async function getChainId(client) {
    const chainIdHex = await client.request({ method: 'eth_chainId' });
    return hexToNumber(chainIdHex);
}
//# sourceMappingURL=getChainId.js.map